module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('div', {
    staticClass: "moileParticulars"
  }, [(this.previewUrl) ? _c('div', {
    staticClass: "video",
    attrs: {
      "id": "videoPlay"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.iframeHtml)
    }
  }) : _c('div', {
    staticStyle: {
      "position": "relative",
      "background": "left top no-repeat",
      "background-size": "100% 100%"
    }
  }, [(this.previewImg) ? _c('img', {
    staticClass: "previewImg",
    attrs: {
      "src": this.previewImg
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "playVideo",
    attrs: {
      "src": "https://static.yun.chinahrt.com/Appfiles/customer_examination1-vue/static/images/playVideo.png",
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.startStudy()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "particularsTitle cb"
  }, [_c('h4', {
    staticClass: "videoTitle"
  }, [_vm._v("\n          " + _vm._s(_vm.goodDetail.goodsTypeName) + " | " + _vm._s(_vm.goodDetail.goodsName) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "LabelTime"
  }, [_c('span', {
    staticClass: "times"
  }, [_vm._v(_vm._s(_vm.goodDetail.testHours) + "\n            "), _c('span', {
    staticStyle: {
      "color": "#ee0a24"
    }
  }, [_vm._v("学时")])])])]), _vm._v(" "), _c('van-tabs', {
    attrs: {
      "line-width": "0.6rem",
      "title-active-color": "#000000",
      "color": "#dc0021",
      "title-inactive-color": "#999999"
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "目录"
    }
  }, [_c('div', {
    staticClass: "particularsTab2"
  }, [_c('van-collapse', {
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, _vm._l((_vm.goodDetail.chapterList), function(chapters) {
    return _c('van-collapse-item', {
      key: chapters.id,
      attrs: {
        "title": chapters.name,
        "name": chapters.name
      }
    }, [_c('ul', _vm._l((chapters.sections), function(section) {
      return _c('li', {
        key: section.id,
        staticClass: "finish",
        class: {
          activess: section.activess
        }
      }, [_c('div', [_c('a', {
        attrs: {
          "href": "javascript:void(0)"
        },
        on: {
          "click": function($event) {
            return _vm.startStudy(section.id)
          }
        }
      }, [_c('div', {
        staticClass: "timeUp"
      }, [_c('van-icon', {
        staticClass: "play fl",
        attrs: {
          "name": "play-circle"
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "time fl chaperList_he"
      }, [_vm._v(_vm._s(section.name))]), _vm._v(" "), _c('li', [_c('span', {
        class: section.studyStatus == '学习中' ? _vm.time : ''
      }, [_vm._v(_vm._s(section.studyStatus))]), _vm._v(" "), (section.studyStatus == '学习中') ? _c('span', [_vm._v(_vm._s(section.studyTime))]) : _vm._e()]), _vm._v(" "), (_vm.isAdd == 0 && _vm.isFree == 0) ? _c('span', {
        staticStyle: {
          "padding-top": "0.133333rem"
        }
      }, [_c('img', {
        attrs: {
          "src": require("../../../static/images/mobile/lock.png"),
          "alt": ""
        }
      })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
        staticClass: "cb timeDown"
      }, [_c('span', {
        staticClass: "time videoText"
      }, [_vm._v(_vm._s(section.duration))])])]), _vm._v(" "), _c('div', {
        staticClass: "cb"
      })])])
    }), 0)])
  }), 1)], 1)]), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "简介"
    }
  }, [_c('div', {
    staticClass: "particularsTab"
  }, [_c('div', {
    staticClass: "introduce_he"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.goodDetail.goodsDesc)
    }
  })]), _vm._v(" "), (
    _vm.goodDetail.teacherList && _vm.goodDetail.teacherList.length > 0
  ) ? _c('div', {
    staticClass: "introduce_he"
  }, [_c('h5', [_c('i', {
    staticClass: "coursePoint"
  }, [_c('img', {
    attrs: {
      "src": "https://static.yun.chinahrt.com/Appfiles/customer_examination1-vue/static/images/coursePoint.png",
      "alt": ""
    }
  })]), _vm._v("讲师介绍\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "divderLine"
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.goodDetail.teacherList), function(teacher) {
    return _c('div', {
      key: teacher.id,
      staticClass: "teacher"
    }, [_c('div', {
      staticClass: "teacherLabel_introduce"
    }, [_c('img', {
      staticClass: "teacherImg fl",
      attrs: {
        "src": teacher.photoUrl
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "fr nameLabel"
    }, [_c('h6', {
      staticClass: "fl teacherName"
    }, [_vm._v(_vm._s(teacher.name))]), _vm._v(" "), _c('p', {
      staticClass: "fl teach"
    }, [_vm._v(_vm._s(teacher.teacherDesc))])])]), _vm._v(" "), _c('p', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(teacher.feature))]), _vm._v(" "), _c('div', {
      staticClass: "cb"
    })])
  })], 2)])], 1)], 1)]), _vm._v(" "), _c('van-tabbar', {
    model: {
      value: (_vm.actives),
      callback: function($$v) {
        _vm.actives = $$v
      },
      expression: "actives"
    }
  }, [_c('van-tabbar-item', {
    attrs: {
      "to": "/mobileHome"
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(props) {
        return [_c('img', {
          attrs: {
            "src": props.active ? _vm.index.active : _vm.index.inactive
          }
        })]
      }
    }])
  }, [_c('span', [_vm._v("首页")])]), _vm._v(" "), _c('van-tabbar-item', {
    attrs: {
      "to": "/mobileStudy"
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(props) {
        return [_c('img', {
          attrs: {
            "src": props.active ? _vm.classes.active : _vm.classes.inactive
          }
        })]
      }
    }])
  }, [_c('span', [_vm._v("班级")])]), _vm._v(" "), _c('van-tabbar-item', {
    attrs: {
      "to": "/mobileMy"
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(props) {
        return [_c('img', {
          attrs: {
            "src": props.active ? _vm.my.active : _vm.my.inactive
          }
        })]
      }
    }])
  }, [_c('span', [_vm._v("我的")])])], 1), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "show-confirm-button": false
    },
    model: {
      value: (_vm.faceDialogFlag),
      callback: function($$v) {
        _vm.faceDialogFlag = $$v
      },
      expression: "faceDialogFlag"
    }
  }, [_c('iframe', {
    ref: "Iframes",
    staticClass: "faceframe",
    attrs: {
      "src": _vm.faceUrl,
      "scrolling": "no",
      "allow": "microphone;camera;midi;encrypted-media"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-f10b7bf0"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/MobileCourseDetail.vue
// module id = 1175
// module chunks = 41